
// // .... 25.03 oncesi
import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from 'react-router-dom';
import '../../styles/Triggers.css';
import RobotSelection from '../Common/RobotSelection';
import axios from 'axios';
import config from '../../config/config';
import ProcessSelection from '../Common/ProcessSelection';
import FolderSelection from '../Common/FolderSelection';
import { toast } from 'react-toastify';
import { useTenant } from '../../context/TenantContext';  

const EditEmailTrigger = () => {
  const { id } = useParams();
  const { selectedTenant } = useTenant();  // Add this line
  const [platform, setPlatform] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [filters, setFilters] = useState([]);
  const [folder, setFolder] = useState('');
  const [process, setProcess] = useState({ id: '', name: '' });
  const [robot, setRobot] = useState('All');
  const [argumentsList, setArgumentsList] = useState([]);
  const [name, setName] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  const isFirstLoad = useRef(true);

  const connectorMapping = {
    'imap.gmail.com': 'Gmail',
    'imap-mail.outlook.com': 'Outlook'
  };


  
  // Add this to your fetchEmailTriggers function after the other state updates
  const fetchEmailTriggers = async () => {
    try {
      const token = localStorage.getItem('userToken');
      const response = await axios.get(`${config.API_BASE_URL}/api/emailTrigger/${id}`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      const data = response.data;
      console.log("📦 Loaded Trigger Data:", data);  // Add this to debug

  
      // Set basic fields
      setFolder(data.folder_id?.toString() || '');
      setProcess({ 
        id: data.process_id?.toString() || '',
        dbId: data.process_id?.toString() || '',
        name: '' 
      });
      setPlatform(connectorMapping[data.platform] || data.platform);
      setUsername(data.email_address || '');
      setPassword(data.email_password || '');
      setRobot(data.robot_id?.toString() || '');
      setName(data.name || '');
      setStatus(data.status || '');
      setArgumentsList(data.argumentsList || []);

      // Set filters
      const newFilters = [];
      if (data.subject_filter) {
        newFilters.push({ 
          field: 'Subject', 
          condition: data.filter_condition || 'Contains', 
          value: data.subject_filter 
        });
      }
      if (data.body_filter) {
        newFilters.push({ 
          field: 'Body', 
          condition: data.filter_condition || 'Contains', 
          value: data.body_filter 
        });
      }
      if (data.from_filter) {
        newFilters.push({ 
          field: 'From', 
          condition: data.filter_condition || 'Contains', 
          value: data.from_filter 
        });
      }
      setFilters(newFilters.length > 0 ? newFilters : [{ field: '', condition: '', value: '' }]);

      console.log("Priority from response:", data.priority);
      setPriority(data.priority || 'Inherited');
      
      setStickToRobot(Boolean(data.stickto_robot));  
      
    } catch (error) {
      toast.error("Failed to load trigger details. Please try again.");
      console.error('❌ Error fetching email triggers:', error);
    }
  };

  

const [priority, setPriority] = useState("Inherited");
const [stickToRobot, setStickToRobot] = useState(false);
const [formErrors, setFormErrors] = useState({});


const priorities = [
  { value: "Inherited", label: "Inherited", icon: "○" },
  { value: "Critical", label: "Critical", icon: "◊" },
  { value: "Highest", label: "Highest", icon: "≫" },
  { value: "Very high", label: "Very high", icon: "≫" },
  { value: "High", label: "High", icon: "∧" },
  { value: "Medium-high", label: "Medium-high", icon: "⋀" },
  { value: "Medium", label: "Medium", icon: "=" },
  { value: "Medium-low", label: "Medium-low", icon: "⋁" },
  { value: "Low", label: "Low", icon: "∨" },
  { value: "Very low", label: "Very low", icon: "≪" },
  { value: "Lowest", label: "Lowest", icon: "≪" }
];

  // Update the handleEmailTrigger function
  const handleEmailTrigger = async () => {
    try {
      const token = localStorage.getItem('userToken');
      const platformToSave = Object.keys(connectorMapping).find(key => connectorMapping[key] === platform) || platform;

      const emailConfig = {
        emailAddress: username,
        emailPassword: password || undefined,
        platform: platformToSave,
        subjectFilter: filters.find(f => f.field === 'Subject')?.value || '',
        bodyFilter: filters.find(f => f.field === 'Body')?.value || '',
        fromFilter: filters.find(f => f.field === 'From')?.value || '',
        filterCondition: filters[0]?.condition || 'Contains',
        logicCondition: filters.length > 1 ? 'AND' : 'OR',
        process: process?.id || null,
        robot,
        argumentsList,
        priority: priority,
        stickto_robot: stickToRobot
      };

      const payload = {
        name,
        status,
        emailConfig,
        folderId: folder,
      };

      await axios.put(`${config.API_BASE_URL}/api/emailTrigger/${id}`, payload, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      toast.success("Email Trigger updated successfully!");
      navigate('/dashboard');
    } catch (error) {
      toast.error("Failed to update trigger. Please try again.");
      console.error('❌ Error updating trigger:', error.response?.data || error.message);
    }
  };

  
  useEffect(() => {
    fetchEmailTriggers();
  }, []);

 
  useEffect(() => {
    const fetchProcessName = async () => {
      if (!process?.dbId || !folder) return;

      console.log("🔄 Process changed:", process);
      
      try {
        const token = localStorage.getItem("userToken");
        const response = await axios.get(
          `${config.API_BASE_URL}/api/orchestrator/releases/${folder}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'selected-tenant': JSON.stringify(selectedTenant),
              'X-UIPATH-OrganizationUnitId': folder.toString()
            }
          }
        );

        const releases = response.data.releases;
        console.log("📡 Releases from Orchestrator:", releases);
        console.log("🔍 Matching DB ID:", process.dbId);

        // Updated to match using Id instead of Key
        const matched = releases.find(r => String(r.Id) === String(process.dbId));
        console.log("✅ Matched Release:", matched);

        if (matched) {
          setProcess(prev => ({
            ...prev,
            id: matched.Key,  
            name: matched.ProcessKey,
            dbId: matched.Id.toString()  
          }));
        }
      } catch (error) {
        console.error("❌ Error fetching process name:", error);
      }
    };

    fetchProcessName();
  }, [process?.dbId, folder, selectedTenant]); 

  useEffect(() => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
    } else {
      setProcess({ id: '', name: '' }); // Reset only after initial load
    }
  }, [folder]);

  
  return (
    <div className='dashboard-container'>
      <Helmet><title>Edit Email Trigger</title></Helmet>
      <h2>Edit Email Trigger</h2>

      <div className="form-group">
        <label>Trigger Name *</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter Trigger Name" />
      </div>

      <div className="form-group">
        <label>Select connector *</label>
        <select value={platform} onChange={(e) => setPlatform(e.target.value)}>
          <option value="">Select platform</option>
          <option value="Gmail">Gmail</option>
          <option value="Outlook">Microsoft Outlook 365</option>
        </select>
      </div>

      <div className="form-group">
        <label>Email Username *</label>
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
      </div>

      <div className="form-group">
        <label>Email Password *</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      </div>

      <div className="form-group data-filters">
        <label>Data filters</label>
        <button onClick={() => setFilters([...filters, { field: '', condition: '', value: '' }])}>Add condition</button>
        {filters.map((filter, index) => (
          <div key={index} className="filter-condition">
            <select value={filter.field} onChange={(e) => {
              const updated = [...filters];
              updated[index].field = e.target.value;
              setFilters(updated);
            }}>
              <option value="">Select field</option>
              <option value="Subject">Subject</option>
              <option value="Body">Body</option>
              <option value="From">From</option>
            </select>
            <select value={filter.condition} onChange={(e) => {
              const updated = [...filters];
              updated[index].condition = e.target.value;
              setFilters(updated);
            }}>
              <option value="">Select condition</option>
              <option value="Contains">Contains</option>
              <option value="Equals">Equals</option>
            </select>
            <input value={filter.value} onChange={(e) => {
              const updated = [...filters];
              updated[index].value = e.target.value;
              setFilters(updated);
            }} />
            <button onClick={() => setFilters(filters.filter((_, i) => i !== index))}>Remove</button>
          </div>
        ))}
      </div>

      <div className="form-group">
        <label>Input Arguments</label>
        <button onClick={() => setArgumentsList([...argumentsList, { name: "", value: "" }])}>+</button>
        {argumentsList.map((arg, index) => (
          <div key={index} className="argument">
            <input value={arg.name} onChange={(e) => setArgumentsList(argumentsList.map((a, i) => i === index ? { ...a, name: e.target.value } : a))} />
            <input value={arg.value} onChange={(e) => setArgumentsList(argumentsList.map((a, i) => i === index ? { ...a, value: e.target.value } : a))} />
            <button onClick={() => setArgumentsList(argumentsList.filter((_, i) => i !== index))}>Remove</button>
          </div>
        ))}
      </div>

      <FolderSelection folder={folder} onChange={setFolder} />
      <RobotSelection robot={robot} onChange={setRobot} folder={folder} />
      <ProcessSelection
        process={process}
        onChange={(selected) => {
          console.log("Selected process:", selected);
          if (selected) {
            setProcess({
              id: selected.id,
              name: selected.name,
              dbId: selected.id
            });
          } else {
            setProcess({ id: '', name: '', dbId: '' });
          }
        }}
        folder={folder}
      />

      <div className="form-group process-robot-lock">
        <div className="robot-lock-container">
          <input
            type="checkbox"
            id="stickToRobot"
            checked={stickToRobot}
            onChange={(e) => setStickToRobot(e.target.checked)}
            disabled={robot === 'All'}
          />
          <label htmlFor="stickToRobot" className="robot-lock-label">
            <span className="lock-icon">🔒</span>
            Lock process to selected robot
          </label>
        </div>
        {robot === 'All' ? (
          <small className="help-text warning">
            Select a specific robot to enable process locking
          </small>
        ) : (
          <small className="help-text">
            This process will only be executed by the selected robot
          </small>
        )}
      </div>

      <div className="form-group">
        <label>Job priority *</label>
        <select 
          value={priority} 
          onChange={(e) => setPriority(e.target.value)}
          className={formErrors.priority ? 'error' : ''}
        >
          {priorities.map((p) => (
            <option key={p.value} value={p.value}>
              {p.icon} {p.label}
            </option>
          ))}
        </select>
        {formErrors.priority && <span className="error-text">{formErrors.priority}</span>}
      </div>

      <button onClick={handleEmailTrigger}>Update Trigger</button>
    </div>
  );
};

export default EditEmailTrigger;
